import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { Page as Component } from "~/components/specifics/settings/company_vendors/construction_item_settings/Page";

export function Page() {
	return (
		<ReadiedRoute fallback={<Redirect url="/" />}>
			<Component />
		</ReadiedRoute>
	);
}
